import { Alert } from '@heroui/react'
import { AnimatePresence, motion } from 'framer-motion'
import { useNotifications } from '#shared/lib/notifications'
import styles from './notifications-layout.module.scss'

interface NotificationsLayoutProps {
  children?: React.ReactNode
}

export default function NotificationsLayout({ children }: NotificationsLayoutProps) {
  const { notifications, closeNotification } = useNotifications()

  return (
    <>
      {children}

      <div className={styles.container}>
        <div className={styles.content}>
          <AnimatePresence>
            {notifications.map(notification => (
              <motion.div
                className={styles.alertWrap}
                key={notification.id}
                initial={{ transform: 'translateX(100%)', opacity: 0 }}
                animate={{ transform: 'translateX(0)', opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <Alert color={notification.type} onClose={() => closeNotification(notification.id)}>
                  {notification.content}
                </Alert>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </>
  )
}
